export const REPLACED_PATTERN = /^(?!.* {2})[a-zа-яё0-9№ ]*$/i;
export const REPLACEMENT_PATTERN = /^(?!.* {2})[a-zа-яё0-9№§; ]*$/i;
